import React, { useState } from 'react';
import { Card, Typography, Space, Button, Select, Row, Col, Statistic } from 'antd';
import { ReloadOutlined, FilterOutlined, CheckOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useInAppNotifications } from '../hooks/useInAppNotifications';
import { NotificationList } from '../components/NotificationList';
import { NotificationFilters } from '../types';

const { Title } = Typography;
const { Option } = Select;

const InAppNotificationListView: React.FC = () => {
    const navigate = useNavigate();
    const [showFilters, setShowFilters] = useState(false);
    const {
        notifications, stats, filters, isLoading,
        currentPage, pageSize, totalElements,
        updateFilters, goToPage, changePageSize,
        refreshNotifications, markAsRead, markAllAsRead, isMarkingAllAsRead,
    } = useInAppNotifications();

    return (
        <div style={{ minHeight: '100vh', padding: 24, background: '#f0f2f5' }}>
            <div style={{ maxWidth: 1200, margin: '0 auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                    <Title level={2} style={{ margin: 0 }}>Notifications</Title>
                    <Space>
                        <Button icon={<FilterOutlined />} onClick={() => setShowFilters(!showFilters)}>Filters</Button>
                        <Button icon={<ReloadOutlined />} onClick={refreshNotifications} loading={isLoading}>Refresh</Button>
                        {stats && stats.unreadCount > 0 && (
                            <Button type="primary" icon={<CheckOutlined />}
                                onClick={markAllAsRead} loading={isMarkingAllAsRead}>
                                Mark All Read ({stats.unreadCount})
                            </Button>
                        )}
                    </Space>
                </div>

                {stats && (
                    <Row gutter={16} style={{ marginBottom: 24 }}>
                        {[
                            { title: 'Total', value: stats.totalCount, color: '#1890ff' },
                            { title: 'Unread', value: stats.unreadCount, color: '#f5222d' },
                            { title: 'Attended', value: stats.attendedCount, color: '#52c41a' },
                            { title: 'Expired', value: stats.expiredCount, color: '#faad14' },
                        ].map(({ title, value, color }) => (
                            <Col xs={6} key={title}>
                                <Card>
                                    <Statistic title={title} value={value} valueStyle={{ color }} />
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}

                {showFilters && (
                    <Card style={{ marginBottom: 24 }}>
                        <Row gutter={16} align="middle">
                            <Col xs={8}>
                                <Select
                                    placeholder="All notifications"
                                    value={filters.unreadOnly}
                                    onChange={(v) => updateFilters({ ...filters, unreadOnly: v })}
                                    style={{ width: '100%' }}
                                    allowClear
                                >
                                    <Option value={true}>Unread only</Option>
                                    <Option value={false}>All</Option>
                                </Select>
                            </Col>
                            <Col xs={4}>
                                <Button onClick={() => updateFilters({})}>Clear</Button>
                            </Col>
                        </Row>
                    </Card>
                )}

                <Card>
                    <NotificationList
                        notifications={notifications}
                        loading={isLoading}
                        showPagination
                        currentPage={currentPage}
                        pageSize={pageSize}
                        totalElements={totalElements}
                        onPageChange={(page, size) => {
                            goToPage(page);
                            if (size !== pageSize) changePageSize(size);
                        }}
                        onNotificationClick={(n) => navigate(`/notifications/${n.id}`)}
                        onMarkAsRead={markAsRead}
                    />
                </Card>
            </div>
        </div>
    );
};

export { InAppNotificationListView };
